<template>
  <header class="hero is-primary is-light is-small">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">Advanced text editor</h1>
        <h2 class="subtitle">Front-end Software Developer</h2>
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.hero.is-small {
  .hero-body {
    padding: 16px;
    .container {
      max-width: 720px;
    }
    .title {
      margin: 0;
      font-size: 24px;
      line-height: 1.35;
    }
    .subtitle {
      margin: 0;
      font-size: 16px;
      line-height: 1.35;
    }
  }
}
</style>
